import { render, staticRenderFns } from "./ImpactCounterHome.vue?vue&type=template&id=b4adef6a&"
import script from "./ImpactCounterHome.vue?vue&type=script&lang=js&"
export * from "./ImpactCounterHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports